export default `<!DOCTYPE html><html lang="en">
   <head>
     {{customFont}}
      <style type="text/css">
      @page {
    margin: 5px;
  }
      * { print-color-adjust:exact !important; }
html {
    -webkit-text-size-adjust: 100%;
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    font-family: Roboto;
    line-height: 1.5;
    tab-size: 4
}

body {
    line-height: inherit;
    margin: 0;
    
}


.main-container {
    padding: 0.5rem;
    padding-top: 1rem;
    width: 793px;
    margin-left: auto;
    margin-right: auto;
    display: grid;
}

.main-grid-gap {
    gap: 1rem;
    row-gap: 1rem;
    display: grid;
}



.header-container {
    gap: 1rem;
    row-gap: 1.5rem;
    width: 793px;
    display: grid;
    margin-left: auto;
    margin-right: auto;
        background-image: linear-gradient(to right,#678aae, #2f5b8e);
}

.footer-text {
    font-size: .5rem;
}

.zone-header {
    position: relative;
    max-width: 250px;
    text-align: center;
    margin: auto;
    background-image: linear-gradient(to right,#88c2df,#2f5b8e);
    border-radius: 1rem;
    top: -28px;
    color: rgb(255 255 255);
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 1.75rem;
    padding-left: 3rem;
    padding-right: 3rem;
}

.zone-bleue {
    padding: 0.75rem;
    border-style: solid;
    border-color: rgb(47 91 142);
    border-width: 4px;
    border-radius: 1rem;
}

.zone-grise {
    padding: 0.75rem;
    border-style: solid;
    border-color: rgb(209 216 227);
    border-width: 4px;
    border-radius: 1rem;
    background-image: linear-gradient(to right,#e1e6ed,#d1d8e3);
}


.grid {
    display: grid;
}


.col-span-1 {
    grid-column: span 1/span 1
}

img {
    max-width: 100%;
    height: auto;
}

.grid-cols-2 {
    grid-template-columns: repeat(2,minmax(0,1fr));
}
.grid-cols-3 {
    grid-template-columns: 2fr 1fr 1fr;
}

.text-center {
    text-align: center;
}

.gap-4 {
    gap: 1rem;
    row-gap: 1.5rem;
}

.header-logo {
    height: 4rem;
    margin-left: auto;
    margin-right: auto;
    /* height: auto; */
    max-width: 100%;
}

.font-bold {
    font-weight: 700
}
.pt-4 {
    padding-top: 1rem
}
     .pdfcontainer .main-grid-gap {
            gap: 1rem;
            row-gap: 1.5rem;
            display: grid;
        }



      .pdfcontainer .header-container {
        gap: 1rem;
        row-gap: 1.5rem;
    width: 793px;
        display: grid;
        margin-left: auto;
        margin-right: auto;
        background: #2f5b8e;/*linear-gradient(to right,#678aae, #2f5b8e);*/
      }

      .pdfcontainer .footer-text {
        margin-top: 15px;
        font-size: .65rem;
        line-height: 0.9rem;
      }

      .pdfcontainer .zone-header {
        position: relative;
        max-width: 250px;
        text-align: center;
        margin: auto;
        background: #2f5b8e;/*linear-gradient(to right,#88c2df,#2f5b8e);*/
        border-radius: 1rem;
        top: -28px;
        color: rgb(255 255 255);
        font-weight: 700;
        font-size: 1.125rem;
        line-height: 1.75rem;
        padding-left: 3rem;
        padding-right: 3rem;
      }

      .pdfcontainer .zone-bleue {
        padding: 0.75rem;
        border-style: solid;
        border-color: #2F5B8E;
        border-width: 4px;
        border-radius: 1rem;
      }

      .pdfcontainer .zone-grise {
        padding: 0.75rem;
        border-style: solid;
        border-color: rgb(209 216 227);
        border-width: 4px;
        border-radius: 1rem;
        background: #e1e6ed;/*linear-gradient(to right,#e1e6ed,#d1d8e3);*/
      }


      .pdfcontainer .grid, .pdfcontainer .grid-row{
        display: grid;
      }


      .pdfcontainer .col-span-1 {
        grid-column: span 1/span 1
      }


       .pdfcontainer  img {
            max-width: 100%;
            height: auto;
        }
      .pdfcontainer .grid-cols-2 {
        grid-template-columns: repeat(2,minmax(0,1fr));
      }

      .pdfcontainer .text-center {
            text-align: center;
        }

      .pdfcontainer .gap-4 {
        gap: 1rem;
        row-gap: 1.5rem;
      }

      .pdfcontainer .header-logo {
        height: 4rem;
        margin-left: auto;
        margin-right: auto;
        /* height: auto; */
        max-width: 100%;
      }

      .pdfcontainer .chirurgien-logo {
        max-height: 40px;
        width: auto;
      }

      .pdfcontainer .font-bold {
        font-weight: 700;
        font-family: 'Roboto-Bold';
      }
      .pdfcontainer .text-center {
        text-align: center;
      }

      .pdfcontainer .round {
        border-radius: 50%;
        background-color: grey;
        width: 20px;
        height: 20px;
        margin: 3px auto;
      }
      .pdfcontainer .pt-4 {
        padding-top: 1rem
      }



.pdfcontainer .zone-bleue .grid, .pdfcontainer .zone-grise .grid {
    margin-top: -28px;
}

      .pdfcontainer .grid-cols-3 {
        grid-template-columns: 2fr 1fr 1fr;
      }

      .pdfcontainer .items-center {
        align-items: center;
        vertical-align: center;
      }
      </style> 
   </head>
   <body class="pdfcontainer">
      <div class="pdfcontainer" #print style="letter-spacing: 0.01px;">
      <div class="header-container">
        <img class="header-logo" src="data:image/png;base64,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" alt="Logo IRIDIS">
      </div>
      <div class="main-container">
         <div class="main-grid-gap">
         <div class="grid grid-cols-2 gap-4">
            <div class="grid col-span-1 gap-4">
               <div class="zone-bleue">{{chirurgien}}</div>
               <div class="zone-grise">
                  <div class="zone-header">Data</div>
                  <div class="grid">
                     <div><span class="font-bold" >Age : </span> <span>{{age}} years</span></div>
                     <div><span class="font-bold">Size : </span> <span>{{size}} cm</span></div>
                     <div><span class="font-bold">Gender : </span> <span>{{sexe}}</span></div>
                     <div class="flex items-center"><span class="font-bold">History of refractive surgery:  {{antecedant}}</span></div>
                     <div class="flex items-center"><span class="font-bold">History of crystalline surgery:  {{antecedantCristallin}}</span></div>
                     <div class="flex items-center"><span class="font-bold">The patient agrees to wear glasses:</span> <span style="margin-top:4px;">{{lunettes}}</span></div>
                     <div class="flex items-center"><span class="font-bold">The patient accepts the photic effects: </span> <span style="margin-top:4px;">{{photiques}}</span></div>
                  </div>
               </div>
            </div>
            <div class="zone-bleue">
               <div class="flex justify-center">{{habitudesVisuelles}}</div>
            </div>
         </div>
         <div class="zone-bleue" >
            <div class="zone-header">Curves</div>
            <div>{{courbes}}</div>
         </div>
         <div class="grid grid-cols-2 gap-4">
            <div class="zone-bleue">
               <div class="zone-header">Biometrics</div>
               <div class="grid ">
                  <div class="grid-row grid-cols-3">
                    <div class="font-bold"></div>
                    <div class="font-bold text-center">Right eye</div>
                    <div class="font-bold text-center">Left eye</div>
                  </div>
                  <div class="grid-row grid-cols-3">
                    <div class="font-bold">Tears</div>
                    <div class="font-bold text-center"><div class="round" style="background:{{larmesOD}}"></div></div>
                    <div class="font-bold text-center"><div class="round" style="background:{{larmesOG}}"></div></div>
                  </div>
                    <div class="grid-row grid-cols-3">
                    <div class="font-bold">HOA</div>
                    <div class="font-bold text-center"><div class="round" style="background:{{aberrationOrdreEleveOD}}"></div></div>
                    <div class="font-bold text-center"><div class="round" style="background:{{aberrationOrdreEleveOG}}"></div></div>
                  </div>
                  <div class="grid-row grid-cols-3">
                    <div class="font-bold">Sph. Ab</div>
                    <div class="font-bold text-center"><div class="round" style="background:{{aberrationSpheriqueOD}}"></div></div>
                    <div class="font-bold text-center"><div class="round" style="background:{{aberrationSpheriqueOG}}"></div></div>
                  </div>
                  <div class="grid-row grid-cols-3">
                    <div class="font-bold">Endothelium</div>
                    <div class="font-bold text-center"><div class="round" style="background:{{endotheliumOD}}"></div></div>
                    <div class="font-bold text-center"><div class="round" style="background:{{endotheliumOG}}"></div></div>
                  </div>
                  <div class="grid-row grid-cols-3">
                    <div class="font-bold">Pupil diameter</div>
                    <div class="font-bold text-center"><div class="round" style="background:{{diametrePupillaireOD}}"></div></div>
                    <div class="font-bold text-center"><div class="round" style="background:{{diametrePupillaireOG}}"></div></div>
                  </div>
                  <div class="grid-row grid-cols-3">
                    <div class="font-bold">Retina/Optic Nerve</div>
                    <div class="font-bold text-center"><div class="round" style="background:{{retineNerfOptiqueOD}}"></div></div>
                    <div class="font-bold text-center"><div class="round" style="background:{{retineNerfOptiqueOG}}"></div></div>
                  </div>
                  <div class="grid-row grid-cols-3">
                    <div class="font-bold">Axial length</div>
                    <div class="font-bold text-center"><div class="round" style="background:{{longueurAxialeOD}}"></div></div>
                    <div class="font-bold text-center"><div class="round" style="background:{{longueurAxialeOG}}"></div></div>
                  </div>
               </div>
            </div>
            <div class="zone-grise">
               <div class="zone-header">Final choice</div>
               <div class="grid">
                  <div class="font-bold">Implant type: {{typeImplant}}</div>
                  <div class="font-bold">Material: {{materiau}}</div>
                  <div class="font-bold">Implant name: {{implant}}</div>
                  <div class="font-bold">Monovision: {{monovision}}</div>
                  <div class="font-bold">Need glasses: {{infoLunettes}}</div>
               </div>
            </div>
         </div>
           </div>
         <div class="footer-text">IOL MATCH does not replace the analysis and expertise of the physician, and cannot be held responsible for the final choice. IOL MATCH is only an additional tool to transcribe visual habits and needs in order to better assist the doctor and the patient during the decision-making process for intraocular implantation</div>
      </div>
      </div>
   </body>
</html>
`;
